(function () {
  const script = document.createElement('script');
  const url = '//compare.onetwotrip.com/javascripts/v1/p/alt_core.js';
  script.src = url;
  script.async = true;
  document.getElementsByTagName('head')[0].appendChild(script);
})();
